import { Size } from '@user-portal/wikr-components';

import { Button } from 'components/library';

import * as S from './styled';

type OutlinedButtonPropsType = {
  onClick: () => void;
  dataLocator?: string;
  mb?: number;
  isLoading?: boolean;
  size?: Size;
};

const OutlinedButton = ({
  onClick,
  dataLocator,
  mb,
  isLoading,
  size,
  children,
}: OutlinedButtonPropsType & { children: React.ReactNode }) => {
  return (
    <S.Container $mb={mb} $borderRadius={12} $borderColor="border-default">
      <Button
        isLoading={isLoading}
        disabled={isLoading}
        size={size}
        textColor="text-main"
        onClick={onClick}
        dataLocator={dataLocator}
      >
        {children}
      </Button>
    </S.Container>
  );
};

export default OutlinedButton;
